<template>
  <i :class="iconClass + ' mb-1'" :style="(shadow ? 'text-shadow: 0 0 2px black; ' : '') + 'color: ' + color"> </i>
</template>

<script>
export default {
  props: {
    iconClass: { type: String, default: 'bi bi-square-fill' },
    color: { type: String, default: 'white' },
    shadow: { type: Boolean, default: true },
  },
  setup() {
    return {};
  },
};
</script>
